import Model from "../Model";

class UserApp extends Model{

    buildUrl ({ param }) {
        return ['useradmin/get', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new UserApp;